/**
 * StickerDeleteReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StickerDeleteReq
 */
export interface StickerDeleteReq {
  /** 表情包ID */
  id: string
  /** 删除原因 */
  reason?: string
}

/**
 * StickerDeleteReq Schema
 */
export const StickerDeleteReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '表情包ID',
      format: 'string',
      type: 'string',
      label: '表情包ID',
    },
    reason: {
      description: '删除原因',
      format: 'string',
      maxLength: 200,
      type: 'string',
      label: '删除原因',
    },
  },
  required: ['id'],
  type: 'object',
}
